import { useGooglePlacesAPI } from 'ComponentLibrary/src/molecules/AddressSearch/useGooglePlacesAPI'
import { useGoogleGeocoderAPI } from 'ComponentLibrary/src/molecules/AddressSearch/useGoogleGeocoderAPI'

type UseGoogleSearchBarProps = {
    apiKey: string
    language?: string
    onError?: (error: Error) => void
}
export function useGoogleSearchBar(props: UseGoogleSearchBarProps) {
    const { fetchPlaceSuggestionsAsync } = useGooglePlacesAPI(props)
    const { fetchPlaceDetails, placeDetails, isPending, finishedInitialization: hasPlaceDetailsServiceLoaded } = useGoogleGeocoderAPI(props)

    return {
        hasPlaceDetailsServiceLoaded,
        fetchPlaceSuggestionsAsync,
        fetchPlaceDetails,
        placeDetails,
        isPending,
    }
}
